import { useState } from "react";
import { Flex, useMediaQuery } from "@chakra-ui/react";

import MENU_TRANSACOES_MOCK  from "mocks/menuTransacoes";

import { SecondHeader } from "components/SecondHeader";
import { NavMenu } from "components/NavMenu";
import { HeadingTable } from "./components/HeadingTable";
import { TableCupons } from "./components/TableCupons";

export default function CupomPage() {
  const [isMobileSize] = useMediaQuery("(max-width: 992px)");
  const [isShowTable, setIsShowTable] = useState(true); 

  return (
    <>
      <SecondHeader />
      <Flex width="100%" maxWidth="1420px" height="auto" margin="0px auto">
        {!isMobileSize && (
          <Flex width="100%" maxWidth="288px">
            <NavMenu
              fontColorActive={"#10125A"}
              menuList={MENU_TRANSACOES_MOCK}
              isTransaction
              routeName="Lista de cupons"
            />
          </Flex>
        )}

        <Flex width="100%" marginTop={isMobileSize ? '20px' : "50px"}>
          <Flex
            flexDirection="column"
            width="100%"
            padding={isMobileSize ? "0px 15px" : "none"}
          >
            <HeadingTable
              isShowTable={isShowTable}
              setIsShowTable={setIsShowTable}
            />
            {isMobileSize ? (
              <>{isShowTable && <TableCupons />}</>
            ) : (
              <TableCupons />
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}
